// <salesol-origin> — canvas host for the Origin World hero. Classic script; lazily imports the engine module.
// The GPU gate (snippets/engine-importmap.liquid) decides first. Without a usable GPU (window.SALESOL_GL resolves false) the
// engine and Three.js are never fetched: the host takes the same stub the engine returns when it finds no WebGL, so the
// mark intro and "Explore origin" (hero-lede.liquid) take the path they always took without WebGL, at once instead of after
// the download. A page without the gate imports as before. An engine that mounts without a world marks data-gl="off" too,
// so the hero shows the same still sky either way.
(function () {
  if (customElements.get('salesol-origin')) return;
  let base = document.baseURI;
  try { const s = document.currentScript && document.currentScript.src; if (s && /^https?:/.test(s)) base = s; } catch (e) {}
  const url = new URL('./salesol-origin-engine.js', base).href;
  const off = () => document.documentElement.setAttribute('data-gl', 'off');
  class El extends HTMLElement {
    connectedCallback() {
      if (this._m) return; this._m = true; this.style.display = 'block';
      const go = (ok) => {
        if (!this.isConnected || !this._m || this._api) return;
        if (!ok) { this._api = { dispose() {} }; return; }
        import(url).then(m => { if (this.isConnected) { this._api = m.mount(this, this.dataset); if (!this.__salesolOrigin) off(); } }).catch(e => console.error('[salesol-origin] engine failed to load', e));
      };
      const gate = window.SALESOL_GL;
      if (gate && typeof gate.then === 'function') gate.then(go, () => go(true)); else go(true);
    }
    disconnectedCallback() { if (this._api) this._api.dispose(); this._api = null; this._m = false; }
  }
  customElements.define('salesol-origin', El);
})();
